(function () {
  function escapeHtml(value) {
    return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function getDrawer() { return document.getElementById('tpCartDrawer'); }
  function getDrawerConfig(attribute, fallback) {
    const drawer = getDrawer();
    const value = drawer ? drawer.dataset[attribute] : null;
    return value || fallback;
  }

  /* ======================= LIVRAISON OFFERTE =======================
     Les deux seuils viennent de shop.metafields.custom.vip_config, via
     #tpVipConfig : SEUIL PUBLIC = seuil_public_cents (cle publicThreshold,
     4990 centimes = 49,90 EUR par defaut) ; SEUIL MEMBRE VIP =
     seuil_livraison_cents (cle shipThreshold, 3990). Aucun seuil a modifier ici.
     REGLE (depuis le 19/09/2026) : le seuil s'evalue sur les produits
     EXPEDIABLES du panier, REMISES DEDUITES (final_line_price), exactement
     comme Shopify evalue le tarif natif France « offert des 49,90 € » et la
     remise automatique « Livraison offerte VIP » (segment membres, minimum
     39,90 €). Le theme ne pose plus aucun code interne : les anciens codes
     TP-LIVRAISON-49 / TP-VIP-LIVRAISON-39 (minimum technique inferieur au
     seuil, saisissables a la main) ont ete desactives ; s'ils trainent encore
     dans un panier, ils sont retires et jamais affiches comme codes client.
     Les lignes sans expedition (adhesion VIP, abonnements) ne comptent pas. */
  const LEGACY_INTERNAL_CODES = ['TP-LIVRAISON-49', 'TP-VIP-LIVRAISON-39'];

  /* ======================= PROGRAMME VIP =======================
     Configuration lue dans #tpVipConfig (Liquid : shop.metafields.custom.vip_config
     + customer.tags). Aucune remise n'est calculee ici : VIP20 est un code
     Shopify reserve aux membres, les prix exclusifs et la livraison offerte
     VIP sont des remises automatiques Shopify reservees aux membres. Le JS ne
     fait que : afficher le bon seuil, proposer VIP20 quand il rapporte
     reellement quelque chose, et l'appliquer sur demande. */
  let VIP = { member: false };
  try { const n = document.getElementById('tpVipConfig'); if (n) VIP = Object.assign({ member: false }, JSON.parse(n.textContent) || {}); } catch (e) { VIP = { member: false }; }
  /* Eligibilite (C2.4) : le code du profil (VIP.code / VIP.pct : VIP15 15 %
     nouveaux membres et visiteurs, VIP20 20 % membres fondateurs) porte sur
     tous les produits, packs, offres x2/x3 et lots compris, sauf l'adhesion VIP
     elle-meme (et toute ligne d'abonnement). Aucune liste. VIP.otherCode =
     l'autre code VIP, refuse pour ce compte (message dedie). */
  VIP.adhesionProduct = String(VIP.adhesionProduct || '');
  VIP.exclusive = VIP.exclusive || {};
  VIP.pct = Number(VIP.pct) || 20;
  const FREE_SHIPPING_THRESHOLD = Number(VIP.publicThreshold) > 0 ? Number(VIP.publicThreshold) : 4990;
  const INTERNAL_CODES = LEGACY_INTERNAL_CODES.concat(VIP.shipCode ? [String(VIP.shipCode)] : []).map((c) => c.toUpperCase());
  function shipThreshold() { return VIP.member && Number(VIP.shipThreshold) > 0 ? Number(VIP.shipThreshold) : FREE_SHIPPING_THRESHOLD; }
  /* Une ligne compte pour la livraison si elle s'expedie et n'est pas un abonnement. */
  function countsForShipping(item) { return item.requires_shipping !== false && !item.selling_plan_allocation; }
  /* Panier « adhesion seule » : au moins une ligne, aucune ligne expediable
     (adhesion VIP / abonnement sans expedition). Rien a livrer : la barre de
     livraison offerte et la reassurance livraison sont remplacees par une
     phrase « adhesion seule ». Un panier avec au moins un produit expediable
     garde exactement le comportement habituel. */
  function isMembershipOnlyCart(cart) { const items = (cart && cart.items) || []; return items.length > 0 && !items.some(countsForShipping); }
  /* B1 20/10/2026 : avertissement panier mixte VIP (adhésion + produit expédiable) au-dessus de Commander. Retour : supprimer cette fonction et son appel dans updateShippingBar. */ function tpMixedVipNotice(cart) { const items = (cart && cart.items) || []; const mixed = items.some(function (i) { return !!i.selling_plan_allocation; }) && items.some(countsForShipping); const btn = document.getElementById('tpCartCheckoutBtn'); let n = document.getElementById('tpVipMixedNotice'); if (!mixed || !btn || !btn.parentNode) { if (n) n.remove(); return; } if (!n) { n = document.createElement('p'); n.id = 'tpVipMixedNotice'; n.className = 'tp-cart-vip-mixed'; n.setAttribute('role', 'note'); n.style.cssText = 'margin:0 0 10px;padding:10px 12px;border-radius:10px;background:#FFF4E5;border:1px solid #E9B872;color:#3D2A00;font-size:13px;line-height:1.45;text-align:left;'; n.innerHTML = '<strong>Adhésion VIP et produits dans le même panier :</strong> les produits de cette commande sont facturés au <strong>prix public</strong>. Les avantages VIP (code −15 %, prix membres, livraison offerte dès 39,90 €) s’appliqueront à vos <strong>commandes suivantes</strong>, une fois l’adhésion activée, en étant connecté(e) à votre compte. Pour en profiter sur ces produits, réglez d’abord l’adhésion seule, puis commandez-les ensuite.'; } if (n.nextSibling !== btn) btn.parentNode.insertBefore(n, btn); } function setMembershipOnlyMode(els, on) {
    if (els.bar) els.bar.classList.toggle('is-membership-only', on);
    if (els.pct) els.pct.style.display = on ? 'none' : '';
    const stage = els.track ? els.track.parentElement : null;
    if (stage) stage.style.display = on ? 'none' : '';
    /* Reassurance sous « Commander » (snippets/toudoupet-cart-drawer.liquid) :
       texte livraison d'origine conserve dans data-tp-reassure-default et
       restaure des qu'un produit expediable revient dans le panier. */
    const reassure = document.querySelector('.tp-cart-drawer__reassure');
    if (!reassure) return;
    if (!reassure.dataset.tpReassureDefault) reassure.dataset.tpReassureDefault = reassure.innerHTML;
    const mode = on ? 'membership' : 'shipping';
    if (reassure.dataset.tpReassureMode === mode) return;
    reassure.dataset.tpReassureMode = mode;
    reassure.classList.toggle('tp-cart-drawer__reassure--membership', on);
    reassure.innerHTML = on
      ? '<span class="tp-cart-drawer__reassure-icon" aria-hidden="true"><svg class="tp-icon" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 2 4 5v6c0 5 3.4 8.7 8 11 4.6-2.3 8-6 8-11V5l-8-3Z"/><path d="m9 12 2 2 4-4"/></svg></span><span class="tp-cart-drawer__reassure-full">Adhésion ToudouPet VIP : rien n\'est expédié. Vos avantages s\'appliquent à vos prochaines commandes, connecté(e) à votre compte.</span><span class="tp-cart-drawer__reassure-short">Adhésion seule · rien n\'est expédié · avantages sur vos prochaines commandes</span>'
      : reassure.dataset.tpReassureDefault;
  }
  function isVipEligibleItem(item) {
    if (item.selling_plan_allocation) return false;
    return !(VIP.adhesionProduct && String(item.product_id) === VIP.adhesionProduct);
  }
  /* Remise VIP20 d'une unite, au centime comme Shopify : arrondie a
     l'INFERIEUR et calculee par unite (verifie au moteur Shopify le
     05/10/2026 : 17,99 -> 3,59 ; 2 x 17,99 -> 7,18). */
  function vipUnitDiscount(cents) { return Math.floor((Number(cents) || 0) * VIP.pct / 100); }
  /* Economie VIP20 reelle (ce que le code ajoute vraiment) :
     - lignes eligibles sans prix membre : remise VIP20 complete ;
     - lignes en prix membre exclusif : Shopify n'applique qu'UNE remise produit
       par ligne (la plus avantageuse) -> le code n'ajoute que l'ecart, s'il
       est positif, entre VIP20 et le prix membre ; jamais de cumul ;
     - adhesion / abonnements : rien. */
  function vipSavings(cart) {
    return (cart.items || []).reduce((sum, item) => {
      if (!isVipEligibleItem(item)) return sum;
      const qty = Number(item.quantity) || 0;
      const unit = Number(item.original_price) || (qty ? Math.round((item.original_line_price || 0) / qty) : 0);
      const vip = vipUnitDiscount(unit);
      const ex = VIP.exclusive[String(item.variant_id)];
      const already = ex ? Math.max(0, unit - Number(ex)) : 0;
      return sum + Math.max(0, vip - already) * qty;
    }, 0);
  }

  const PACK_DUO_MATCH = String(getDrawerConfig('packDuoMatch', 'pack duo')).toLowerCase();
  const MONEY_FORMAT = getDrawerConfig('moneyFormat', '');
  const FORMAT_RE = /\{\{\s*(\w+)\s*\}\}/;
  const THOUSANDS_RE = /\B(?=(\d{3})+(?!\d))/g;
  const DISMISS_KEY = 'tpUpsellDismissed';
  let lastItemCount = parseInt(getDrawerConfig('itemCount', '0'), 10) || 0;
  let lastCart = null;
  let lastTrigger = null;
  let syncing = false;
  /* Ordre des rendus : chaque lecture du panier prend un numero au depart de
     la requete, chaque mutation a l'arrivee de sa reponse (elle decrit l'etat
     apres modification). Une reponse plus ancienne que le dernier rendu est
     ignoree : deux reponses qui se croisent n'affichent jamais un etat perime. */
  let cartSeq = 0;
  let renderedSeq = 0;
  let lineMutation = null;

  let X2_INDEX = {};
  try { const n = document.getElementById('tpCartX2Index'); if (n) X2_INDEX = JSON.parse(n.textContent) || {}; } catch (e) { X2_INDEX = {}; }
  /* Post-QA (12-10-2026) : libelles clients des options (index tpCartLabels). */
  let LABELS = {};
  try { const ln = document.getElementById('tpCartLabels'); if (ln) LABELS = JSON.parse(ln.textContent) || {}; } catch (e) { LABELS = {}; }
  function optLabel(item, value) { const m = LABELS[String(item.product_id)]; return (m && m[value]) ? m[value] : value; }
  function optValue(item, i) { const o = item.options_with_values || []; return o[i] && o[i].value ? o[i].value : ''; }
  function shortLabel(v) { const p = String(v).split('— '); return p.length > 1 ? p[p.length - 1] : v; }
  function x2Thumb(item) {
    const entry = X2_INDEX[String(item.product_id)];
    if (!entry) return null;
    if (entry.mode === 'hero') return entry.url ? { mode: 'hero', urls: [entry.url] } : null;
    if (entry.mode === 'trio') {
      const c = entry.colors || {};
      const n = entry.n === 3 ? 3 : 2;
      const urls = [];
      for (let i = 0; i < n; i++) { const u = c[optValue(item, i)]; if (u) urls.push(u); }
      return urls.length === n ? { mode: 'multi', urls: urls } : null;
    }
    if (entry.mode === 'duo2') {
      const c = entry.colors || {};
      const u1 = c[optValue(item, 0)] || '';
      const u2 = c[optValue(item, 1)] || u1;
      return u1 ? { mode: 'multi', urls: [u1, u2] } : null;
    }
    let url = '';
    if (entry.variants) url = entry.variants[String(item.variant_id)] || '';
    if (!url && entry.colors) url = entry.colors[optValue(item, typeof entry.opt === 'number' ? entry.opt : 0)] || '';
    return url ? { mode: 'multi', urls: [url, url] } : null;
  }
  function thumbHtml(item) {
    const href = escapeHtml(item.url || '#');
    const x2 = x2Thumb(item);
    if (x2 && x2.mode === 'multi' && x2.urls.length === 3) {
      return `<a class="tp-cart-item__thumb tp-cart-item__thumb--duo tp-cart-item__thumb--trio" href="${href}" tabindex="-1" aria-hidden="true"><span class="tp-cart-item__unit tp-cart-item__unit--u3"><img src="${escapeHtml(x2.urls[2])}" alt="" width="34" height="34" loading="lazy"></span><span class="tp-cart-item__unit tp-cart-item__unit--u2"><img src="${escapeHtml(x2.urls[1])}" alt="" width="34" height="34" loading="lazy"></span><span class="tp-cart-item__unit tp-cart-item__unit--u1"><img src="${escapeHtml(x2.urls[0])}" alt="" width="34" height="34" loading="lazy"></span></a>`;
    }
    if (x2 && x2.mode === 'multi') {
      return `<a class="tp-cart-item__thumb tp-cart-item__thumb--duo" href="${href}" tabindex="-1" aria-hidden="true"><span class="tp-cart-item__unit tp-cart-item__unit--back"><img src="${escapeHtml(x2.urls[1] || x2.urls[0])}" alt="" width="40" height="40" loading="lazy"></span><span class="tp-cart-item__unit tp-cart-item__unit--front"><img src="${escapeHtml(x2.urls[0])}" alt="" width="40" height="40" loading="lazy"></span></a>`;
    }
    if (x2 && x2.mode === 'hero') {
      return `<a class="tp-cart-item__thumb tp-cart-item__thumb--hero" href="${href}" tabindex="-1" aria-hidden="true"><img src="${escapeHtml(x2.urls[0])}" alt="" width="56" height="56" loading="lazy"></a>`;
    }
    return `<a class="tp-cart-item__thumb" href="${href}" tabindex="-1" aria-hidden="true">${item.image ? `<img src="${escapeHtml(resizeImageUrl(item.image, 120))}" alt="" width="56" height="56" loading="lazy">` : ''}</a>`;
  }

  function formatEurosFallback(cents) {
    const v = cents / 100;
    const m = MONEY_FORMAT.match(FORMAT_RE);
    const key = m ? m[1] : 'amount_with_comma_separator';
    const noDec = key.indexOf('no_decimals') !== -1;
    let thousands = ',', decimal = '.';
    if (key.indexOf('comma_separator') !== -1) { thousands = '.'; decimal = ','; }
    if (key.indexOf('space_separator') !== -1) { thousands = ' '; decimal = ','; }
    if (key.indexOf('apostrophe_separator') !== -1) { thousands = "'"; decimal = '.'; }
    const fixed = noDec ? Math.round(v).toString() : v.toFixed(2);
    const parts = fixed.split('.');
    const intPart = parts[0].replace(THOUSANDS_RE, thousands);
    const amount = noDec ? intPart : intPart + decimal + parts[1];
    return m ? MONEY_FORMAT.replace(m[0], amount) : amount + ' €';
  }
  function formatEuros(cents) { return window.ToudouPrice ? window.ToudouPrice.text(cents) : formatEurosFallback(cents); }
  function priceHtml(cents, klass) { return window.ToudouPrice ? window.ToudouPrice.markup(cents, { klass: klass }) : escapeHtml(formatEurosFallback(cents)); }
  function renderPriceInto(el, cents, klass) { if (!el) return; if (window.ToudouPrice) window.ToudouPrice.render(el, cents, { klass: klass }); else el.textContent = formatEurosFallback(cents); }

  function cartHasPackDuo(cart) {
    const packDuoId = getDrawerConfig('packDuoId', '');
    if (packDuoId) return cart.items.some((item) => String(item.product_id) === String(packDuoId));
    return cart.items.some((item) => item.product_title.toLowerCase().includes(PACK_DUO_MATCH));
  }
  function resizeImageUrl(url, width) {
    try { const parsed = new URL(url, window.location.origin); parsed.searchParams.set('width', String(width)); return parsed.toString(); } catch (e) { return url; }
  }
  function variantLabel(item) {
    const entry = X2_INDEX[String(item.product_id)];
    if (entry && (entry.mode === 'duo2' || entry.mode === 'trio')) {
      const n = entry.mode === 'trio' && entry.n === 3 ? 3 : 2;
      const vals = [];
      for (let i = 0; i < n; i++) { const v = optValue(item, i); if (v) vals.push(shortLabel(v)); }
      if (vals.length === n) return 'Couleurs : ' + vals.join(' + ');
    }
    if (Array.isArray(item.options_with_values) && item.options_with_values.length) {
      const parts = item.options_with_values.filter((o) => o && o.value && o.value !== 'Default Title').map((o) => o.name + ' : ' + optLabel(item, o.value));
      if (parts.length) return parts.join(' · ');
    }
    if (item.variant_title && item.variant_title !== 'Default Title') return item.variant_title;
    return '';
  }

  /* ---- Codes presents au panier (client + anciens codes internes) ---- */
  function cartCodes(cart) {
    return (cart.discount_codes || []).map((d) => (d && d.code ? String(d.code) : '')).filter(Boolean);
  }
  function isInternal(code) { return INTERNAL_CODES.includes(String(code).toUpperCase()); }
  function customerCodes(cart) { return cartCodes(cart).filter((c) => !isInternal(c)); }
  /* Codes client reellement appliques : un code refuse par Shopify
     (applicable:false) n'est ni affiche, ni compte comme « deja applique ». */
  function activeCustomerCodes(cart) { return customerCodes(cart).filter((c) => (cart.discount_codes || []).some((d) => d && d.code === c && d.applicable !== false)); }
  /* Lecture d'une reponse panier : statut HTTP verifie, JSON lu une fois.
     Reponse refusee (422 stock, 4xx/5xx) ou panier illisible -> erreur portant
     le message Shopify (description) s'il existe ; l'appelant l'affiche. */
  async function readCartResponse(response, fallback) {
    let data = null;
    try { data = await response.json(); } catch (e) { data = null; }
    if (response.ok === false || !data || !Array.isArray(data.items)) {
      const error = new Error((data && (data.description || data.message)) || fallback);
      error.status = response.status || 0;
      error.detail = data && typeof data.description === 'string' ? data.description : '';
      throw error;
    }
    return data;
  }
  async function fetchCart() { return readCartResponse(await fetch('/cart.js'), 'Panier indisponible'); }
  /* Base du seuil : produits expediables, TOUTES remises deduites.
     F03 (QA 11/10/2026) : final_line_price ne contient que les remises de
     ligne (prix membres, VIP20 par produit...). Les codes de niveau panier
     (ex. BIENVENUE10) n'y figurent pas. Shopify fournit, pour chaque ligne,
     total_discount = toutes les remises reellement allouees a cette ligne
     (ligne + panier) : montant retenu = original_line_price - total_discount,
     sans reconstitution manuelle. Repli sur final_line_price si absent.
     Ex. : 39,99 EUR - BIENVENUE10 (3,99) -> base 36,00 EUR, il manque 13,90 EUR. */
  function lineFinal(item) {
    if (typeof item.original_line_price === 'number' && typeof item.total_discount === 'number') {
      return Math.max(0, item.original_line_price - item.total_discount);
    }
    return typeof item.final_line_price === 'number' ? item.final_line_price : (item.line_price || 0);
  }
  function eligibleBase(cart) {
    return (cart.items || []).reduce((sum, item) => sum + (countsForShipping(item) ? lineFinal(item) : 0), 0);
  }
  function eligibleForFreeShipping(cart) { return eligibleBase(cart) >= shipThreshold(); }
  /* Plus aucun code interne n'est pose. Si un ancien code interne (desactive
     cote Shopify) traine encore dans le panier, on le retire une fois, en
     conservant les codes du client. */
  async function syncInternalDiscount(cart) {
    if (syncing || !cart) return cart;
    const present = cartCodes(cart).filter(isInternal);
    if (!present.length) return cart;
    const codes = customerCodes(cart);
    syncing = true;
    try {
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
      return await fetchCart();
    } catch (e) { return cart; } finally { syncing = false; }
  }
  /* Applique un code CLIENT sans perdre les autres codes. */
  async function applyCustomerCode(code) {
    const cart0 = await fetchCart();
    const codes = cartCodes(cart0).filter((c) => c.toUpperCase() !== String(code).toUpperCase());
    codes.push(code);
    await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) });
  }

  function automaticDiscounts(cart) {
    const map = {};
    (cart.cart_level_discount_applications || []).forEach((a) => { if (a && a.type === 'automatic') map[a.title] = (map[a.title] || 0) + (a.total_allocated_amount || 0); });
    (cart.items || []).forEach((item) => (item.line_level_discount_allocations || []).forEach((alloc) => {
      const app = alloc.discount_application;
      if (app && app.type === 'automatic') map[app.title] = (map[app.title] || 0) + (alloc.amount || 0);
    }));
    return Object.keys(map).map((title) => ({ title, amount: map[title] }));
  }
  function updateAutomaticBlock(cart) {
    const wrap = document.getElementById('tpCartAuto');
    const list = document.getElementById('tpCartAutoList');
    if (!wrap || !list) return;
    const autos = automaticDiscounts(cart).filter((a) => a.amount > 0);
    if (!autos.length) { wrap.hidden = true; list.innerHTML = ''; return; }
    list.innerHTML = autos.map((a) => `<li class="tp-cart-auto__item"><span class="tp-cart-auto__name">${escapeHtml(a.title)}</span><span class="tp-cart-auto__amount">−${priceHtml(a.amount, 'tp-price--compact')}</span></li>`).join('');
    wrap.hidden = false;
  }

  /* ======================= BARRE DE LIVRAISON ANIMEE =======================
     Meme base pre-promo que l'eligibilite (un code promo ne fait jamais
     redescendre la barre). Un seul etat, une seule animation a la fois :
     - ship.shown  : progression reellement affichee (0..1) ;
     - ship.target : progression reelle du panier (0..1) ;
     - ship.raf    : requestAnimationFrame en cours (annule avant chaque
                     nouvelle animation -> jamais deux animations en parallele) ;
     - ship.timers : temporisations de la sequence camion, purgees a la
                     fermeture du drawer.
     Les elements sont relus a chaque appel (aucune reference DOM conservee),
     donc un remplacement AJAX du drawer ne casse rien.
     Ouverture du drawer : barre epaissie, remplissage de 0 vers la valeur
     reelle en ~1 s (easeOutCubic), compteur synchronise, retour a l'epaisseur
     normale ; si le seuil est atteint, sequence camion + confettis.
     Mise a jour du panier (drawer ouvert) : ~400 ms depuis la valeur affichee ;
     camion + celebration uniquement au FRANCHISSEMENT du seuil.
     Drawer ferme ou animations reduites : affichage direct et exact. */
  const REDUCED_MOTION = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  const SHIP_COLORS = ['#E9D2B4', '#3C2A1E', '#C9A46A', '#FFF8F0'];
  const ship = { shown: 0, target: 0, unlocked: false, opening: false, truckPlaying: false, raf: null, timers: [], lastConfetti: 0 };
  function shipEls() {
    return {
      bar: document.getElementById('tpShippingBar'),
      text: document.getElementById('tpShippingText'),
      pct: document.getElementById('tpShippingPct'),
      track: document.getElementById('tpShippingTrack'),
      truck: document.getElementById('tpShippingTruck'),
      confetti: document.getElementById('tpShippingConfetti')
    };
  }
  function shipLater(fn, ms) { const id = window.setTimeout(fn, ms); ship.timers.push(id); return id; }
  function shipClearTimers() { ship.timers.forEach((id) => window.clearTimeout(id)); ship.timers = []; }
  function shipCancelRaf() { if (ship.raf) { window.cancelAnimationFrame(ship.raf); ship.raf = null; } }
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }
  /* Le compteur est tronque (49,89 EUR -> 99 %) : 100 % n'apparait qu'au seuil reel. */
  function paintProgress(ratio) {
    const els = shipEls();
    ship.shown = ratio;
    if (els.track) els.track.style.backgroundSize = (ratio * 100) + '% 100%';
    if (els.pct) els.pct.textContent = Math.floor(ratio * 100 + 1e-9) + ' %';
  }
  function spawnConfetti(count, burst) {
    if (REDUCED_MOTION) return;
    const els = shipEls();
    if (!els.confetti) return;
    for (let i = 0; i < count; i++) {
      const piece = document.createElement('span');
      piece.className = 'tp-ship-confetti' + (burst ? ' tp-ship-confetti--burst' : '');
      piece.style.left = (burst ? 56 + Math.random() * 38 : 12 + Math.random() * 76) + '%';
      piece.style.background = SHIP_COLORS[Math.floor(Math.random() * SHIP_COLORS.length)];
      piece.style.setProperty('--x', (Math.random() * 36 - 18) + 'px');
      piece.style.setProperty('--r', (Math.random() * 300 - 150) + 'deg');
      piece.style.animationDelay = (Math.random() * 0.12) + 's';
      els.confetti.appendChild(piece);
      shipLater(() => piece.remove(), 1150);
    }
  }
  /* Interpole ship.shown -> to. Confettis ponctuels au-dela de 80 % pendant
     une progression montante (jamais en descente, jamais au repos). */
  function animateProgress(to, duration, onDone) {
    shipCancelRaf();
    const from = ship.shown;
    if (REDUCED_MOTION || duration <= 0 || Math.abs(to - from) < 0.0005) { paintProgress(to); if (onDone) onDone(); return; }
    const t0 = performance.now();
    const step = (now) => {
      const t = Math.min(1, (now - t0) / duration);
      const value = from + (to - from) * easeOutCubic(t);
      paintProgress(t < 1 ? value : to);
      if (to > from && value >= 0.8 && value < 1 && now - ship.lastConfetti > 110) { ship.lastConfetti = now; spawnConfetti(1, false); }
      if (t < 1) { ship.raf = window.requestAnimationFrame(step); return; }
      ship.raf = null;
      if (onDone) onDone();
    };
    ship.raf = window.requestAnimationFrame(step);
  }
  function parkTruck() { const els = shipEls(); if (!els.truck) return; els.truck.hidden = false; els.truck.className = 'tp-cart-drawer__shipping-truck is-parked'; }
  function hideTruck() { const els = shipEls(); if (!els.truck) return; els.truck.hidden = true; els.truck.className = 'tp-cart-drawer__shipping-truck'; }
  /* Sequence camion (~1,8 s) : la phrase s'efface (place reservee), le camion
     apparait au depart et bascule vers l'arriere, traverse la piste en
     decelerant, freine avec une legere oscillation, confettis, puis la phrase
     revient et le compteur affiche 100 %. Un seul passage a la fois. */
  function playTruck() {
    const els = shipEls();
    if (!els.truck || !els.track || ship.truckPlaying) return;
    if (REDUCED_MOTION) { parkTruck(); return; }
    ship.truckPlaying = true;
    const truck = els.truck;
    truck.hidden = false;
    truck.className = 'tp-cart-drawer__shipping-truck is-playing is-start';
    if (els.text) els.text.classList.add('is-fading');
    shipLater(() => { truck.classList.remove('is-start'); truck.classList.add('is-driving'); }, 220);
    shipLater(() => { truck.classList.remove('is-driving'); truck.classList.add('is-brake'); spawnConfetti(14, true); }, 1320);
    shipLater(() => {
      truck.className = 'tp-cart-drawer__shipping-truck is-parked';
      const e = shipEls();
      if (e.text) e.text.classList.remove('is-fading');
      paintProgress(1);
      ship.truckPlaying = false;
    }, 1800);
  }
  function finishOpening() {
    ship.opening = false;
    const els = shipEls();
    if (els.bar) els.bar.classList.remove('is-thick');
    if (ship.unlocked) playTruck(); else hideTruck();
  }
  /* Ouverture du drawer : on repart de zero vers la progression reelle. */
  function startOpeningAnimation() {
    const els = shipEls();
    if (!els.track) return;
    shipCancelRaf(); shipClearTimers();
    ship.truckPlaying = false;
    if (els.text) els.text.classList.remove('is-fading');
    if (REDUCED_MOTION) { ship.opening = false; paintProgress(ship.target); if (ship.unlocked) parkTruck(); else hideTruck(); return; }
    hideTruck();
    if (els.bar) els.bar.classList.add('is-thick');
    ship.opening = true;
    ship.shown = 0;
    paintProgress(0);
    animateProgress(ship.target, 1000, finishOpening);
  }
  /* Fermeture ou reconstruction : plus rien ne tourne, rien ne reste. */
  function cleanupShipping() {
    shipCancelRaf(); shipClearTimers();
    ship.opening = false; ship.truckPlaying = false;
    const els = shipEls();
    if (els.confetti) els.confetti.innerHTML = '';
    if (els.bar) els.bar.classList.remove('is-thick');
    if (els.text) els.text.classList.remove('is-fading');
    if (ship.unlocked) parkTruck(); else hideTruck();
  }
  function updateShippingBar(cart) {
    const els = shipEls();
    if (!els.text || !els.track) return;
    const memberOnly = isMembershipOnlyCart(cart);
    setMembershipOnlyMode(els, memberOnly); tpMixedVipNotice(cart);
    if (memberOnly) {
      shipCancelRaf();
      if (ship.opening) finishOpening();
      ship.unlocked = false; ship.target = 0;
      paintProgress(0);
      hideTruck();
      els.track.classList.remove('is-complete');
      els.text.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 2 4 5v6c0 5 3.4 8.7 8 11 4.6-2.3 8-6 8-11V5l-8-3Z"/><path d="m9 12 2 2 4-4"/></svg> <span class="tp-cart-drawer__shipping-msg">Adhésion seule : rien à expédier. Vos avantages membres s\'activent dès la validation du paiement.</span>';
      return;
    }
    const base = eligibleBase(cart);
    const threshold = shipThreshold();
    const truckIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 17h1a2 2 0 1 0 4 0h6a2 2 0 1 0 4 0h1a1 1 0 0 0 1-1v-4l-3-4h-3V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1Z"/><path d="M14 8v5h6"/></svg>';
    const vipTag = VIP.member && threshold !== FREE_SHIPPING_THRESHOLD ? ' <span class="tp-cart-drawer__shipping-vip">VIP</span>' : '';
    const hasDiscount = (cart.items || []).some((item) => countsForShipping(item) && typeof item.final_line_price === 'number' && item.final_line_price < item.original_line_price);
    const baseNote = hasDiscount ? ' <span class="tp-cart-drawer__shipping-note">(remises déduites)</span>' : '';
    /* Ratio borne entre 0 et 1 : la piste ne peut ni deborder ni passer en
       negatif, quel que soit l'etat renvoye par /cart.js. */
    const ratio = Math.min(1, Math.max(0, base / threshold));
    const remaining = Math.max(threshold - base, 0);
    const unlocked = remaining === 0;
    const wasUnlocked = ship.unlocked;
    ship.unlocked = unlocked;
    ship.target = ratio;
    /* Phrase courte : le reste a ajouter d'abord, le cumul / seuil en seconde
       ligne discrete (le texte entier reste lu d'un bloc : aria-atomic). */
    if (unlocked) { els.text.innerHTML = truckIcon + ' <span class="tp-cart-drawer__shipping-msg">Livraison offerte débloquée !' + vipTag + '</span>'; els.track.classList.add('is-complete'); }
    else { els.text.innerHTML = truckIcon + ' <span class="tp-cart-drawer__shipping-msg">Plus que <strong>' + escapeHtml(formatEuros(remaining)) + '</strong> pour la livraison offerte' + vipTag + ' <span class="tp-cart-drawer__shipping-sum">' + escapeHtml(formatEuros(base)) + ' / ' + escapeHtml(formatEuros(threshold)) + baseNote + '</span></span>'; els.track.classList.remove('is-complete'); }
    const drawer = getDrawer();
    const isOpen = !!(drawer && drawer.classList.contains('is-open'));
    if (!isOpen || REDUCED_MOTION) {
      shipCancelRaf();
      paintProgress(ratio);
      if (unlocked) { if (!ship.truckPlaying) parkTruck(); } else hideTruck();
      return;
    }
    if (ship.opening) { animateProgress(ratio, 600, finishOpening); return; }
    if (!unlocked) hideTruck();
    const crossedUp = unlocked && !wasUnlocked;
    animateProgress(ratio, 400, () => {
      if (crossedUp) playTruck();
      else if (unlocked && !ship.truckPlaying) parkTruck();
    });
  }

  function updateEmptyState(count) {
    lastItemCount = count;
    const drawer = getDrawer();
    if (drawer) { drawer.dataset.itemCount = String(count); drawer.classList.toggle('is-empty', count === 0); }
    const checkout = document.getElementById('tpCartCheckoutBtn');
    if (checkout) {
      checkout.classList.toggle('is-disabled', count === 0);
      if (count === 0) checkout.setAttribute('aria-disabled', 'true'); else checkout.removeAttribute('aria-disabled');
    }
  }

  /* ======================= FENETRE MODALE =======================
     Drawer ouvert : les freres du drawer dans <body> (header, contenu, footer,
     bandeau cookies, popup...) recoivent l'attribut inert -> ni Tab, ni
     lecteur d'ecran, ni clic n'y accedent. Seuls les elements rendus inertes
     ici sont liberes a la fermeture (un inert pose par un autre script reste).
     Repli pour les navigateurs sans inert : Tab / Maj+Tab bouclent entre le
     premier et le dernier element visible du panneau (meme logique que le
     popup promo). */
  let inertNodes = [];
  function setBackgroundInert(on) {
    const d = getDrawer();
    if (!on) { inertNodes.forEach((el) => el.removeAttribute('inert')); inertNodes = []; return; }
    if (!d || inertNodes.length) return;
    Array.from(document.body.children).forEach((el) => {
      if (el === d || el.contains(d) || el.hasAttribute('inert') || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName)) return;
      el.setAttribute('inert', '');
      inertNodes.push(el);
    });
  }
  function panelFocusables() {
    const d = getDrawer();
    const panel = d ? d.querySelector('.tp-cart-drawer__panel') : null;
    if (!panel) return [];
    return Array.from(panel.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex]'))
      .filter((el) => !el.disabled && el.getAttribute('tabindex') !== '-1' && el.getClientRects().length > 0);
  }
  function trapTab(e) {
    const d = getDrawer();
    if (!d || !d.classList.contains('is-open')) return;
    const items = panelFocusables();
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    const active = document.activeElement;
    if (!d.contains(active)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }

  function openCartDrawer(trigger) {
    const d = getDrawer();
    if (!d) return;
    if (trigger && trigger.focus) lastTrigger = trigger;
    else if (document.activeElement && document.activeElement !== document.body && !d.contains(document.activeElement)) lastTrigger = document.activeElement;
    const wasOpen = d.classList.contains('is-open');
    d.classList.add('is-open');
    /* Verrou de defilement sur <html> (regle commune, toudoupet-header.css) ; classe du body = indicateur d'etat. */
    document.documentElement.classList.add('tp-cart-drawer-open');
    document.body.classList.add('tp-cart-drawer-open');
    setBackgroundInert(true);
    if (!wasOpen) startOpeningAnimation();
    const closeBtn = document.getElementById('tpCartCloseBtn');
    if (closeBtn) window.setTimeout(() => closeBtn.focus({ preventScroll: true }), 60);
  }
  function closeCartDrawer() {
    const d = getDrawer();
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    document.documentElement.classList.remove('tp-cart-drawer-open');
    document.body.classList.remove('tp-cart-drawer-open');
    setBackgroundInert(false);
    cleanupShipping();
    if (lastTrigger && lastTrigger.isConnected) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} }
    /* Declencheur absent ou non focalisable : le focus ne reste ni sur <body>
       ni dans le panneau ferme, il va a l'icone panier (D3). */
    const active = document.activeElement;
    if (!active || active === document.body || d.contains(active)) { const icon = document.getElementById('tpCartIconBtn'); if (icon) icon.focus({ preventScroll: true }); }
  }
  function updateCartBadge(count) { document.querySelectorAll('.tp-site-header__cart-count').forEach((el) => { el.textContent = count; }); }

  /* ATTENTION : ce markup a un jumeau Liquid dans snippets/toudoupet-cart-drawer.liquid. */
  function renderCartItems(cart) {
    lastCart = cart;
    const itemsContainer = document.getElementById('tpCartItems');
    const emptyMsg = document.getElementById('tpCartEmpty');
    if (!itemsContainer || !emptyMsg) return;
    const focusBefore = captureFocus(itemsContainer);
    const globalError = document.getElementById('tpCartError');
    if (globalError) { globalError.hidden = true; globalError.textContent = ''; }
    if (cart.item_count === 0) { itemsContainer.innerHTML = ''; emptyMsg.hidden = false; }
    else {
      emptyMsg.hidden = true;
      itemsContainer.innerHTML = cart.items.map((item) => {
        /* Ligne d'abonnement (adhesion VIP) : pas de +/- (une adhesion = un
           contrat), mention du renouvellement automatique, retrait possible. */
        const sub = !!item.selling_plan_allocation;
        const baseVariant = variantLabel(item);
        const variant = sub ? (baseVariant ? baseVariant + ' · ' : '') + 'Renouvellement automatique, résiliable à tout moment' : baseVariant;
        const discounted = item.original_price > item.final_price;
        const unit = (discounted ? `<span class="tp-cart-item__price-old">${priceHtml(item.original_price, 'tp-price--old')}</span> ` : '') + priceHtml(item.final_price, 'tp-price--compact');
        const lineTotal = item.quantity > 1 ? ` <span class="tp-cart-item__line-total">· ${priceHtml(item.final_line_price, 'tp-price--compact')}</span>` : '';
        const qty = sub
          ? `<div class="tp-cart-item__qty tp-cart-item__qty--fixed"><span class="tp-cart-item__qty-value">${item.quantity}</span></div>`
          : `<div class="tp-cart-item__qty">
              <button class="tp-cart-item__qty-btn" type="button" data-action="minus" data-key="${escapeHtml(item.key)}" aria-label="Diminuer la quantité de ${escapeHtml(item.product_title)}">−</button>
              <span class="tp-cart-item__qty-value">${item.quantity}</span>
              <button class="tp-cart-item__qty-btn" type="button" data-action="plus" data-key="${escapeHtml(item.key)}" aria-label="Augmenter la quantité de ${escapeHtml(item.product_title)}">+</button>
            </div>`;
        return `
        <div class="tp-cart-item${discounted ? ' tp-cart-item--discounted' : ''}${sub ? ' tp-cart-item--subscription' : ''}" data-key="${escapeHtml(item.key)}">
          ${thumbHtml(item)}
          <div class="tp-cart-item__info">
            <p class="tp-cart-item__name"><a href="${escapeHtml(item.url || '#')}">${escapeHtml(item.product_title)}</a></p>
            ${variant ? `<p class="tp-cart-item__variant">${escapeHtml(variant)}</p>` : ''}
            <p class="tp-cart-item__price">${unit}${lineTotal}</p>
            ${qty}
          </div>
          <button class="tp-cart-item__remove" type="button" data-action="remove" data-key="${escapeHtml(item.key)}" aria-label="Retirer ${escapeHtml(item.product_title)} du panier">×</button>
        </div>`; }).join('');
    }
    renderPriceInto(document.getElementById('tpCartSubtotal'), cart.total_price);
    updateShippingBar(cart);
    updateCartBadge(cart.item_count);
    updateEmptyState(cart.item_count);
    updateGuideBlock(cart);
    updatePackReco(cart);
    updateUpsellBlock(cart);
    updateAutomaticBlock(cart);
    updatePromoState(cart);
    updateVipBlock(cart);
    restoreFocus(focusBefore);
  }

  /* ======================= FOCUS APRES RE-RENDU =======================
     Le re-rendu remplace les lignes (innerHTML) et peut masquer le bloc qui
     avait le focus (upsell ajoute, VIP20 applique, champ promo). On note
     l'element focalise avant, puis on le retrouve :
     - dans les articles : meme bouton (data-action + data-key) ou meme lien de
       la ligne ; sinon le meme bouton de la ligne suivante, puis precedente ;
       panier vide -> « Decouvrir le catalogue » ;
     - ailleurs dans le panneau, s'il a disparu : « Commander » (panier non
       vide), sinon le bouton Fermer. */
  function captureFocus(itemsContainer) {
    const d = getDrawer();
    const el = document.activeElement;
    if (!d || !el || el === document.body || !d.contains(el)) return null;
    const row = itemsContainer.contains(el) ? el.closest('.tp-cart-item') : null;
    const rows = Array.from(itemsContainer.querySelectorAll('.tp-cart-item'));
    return { el: el, inItems: !!row, key: row ? row.dataset.key : '', action: el.dataset ? el.dataset.action || '' : '', link: el.tagName === 'A', index: row ? rows.indexOf(row) : -1 };
  }
  function isShown(el) {
    const d = getDrawer();
    if (!el || !el.isConnected || el.closest('[hidden]')) return false;
    if (d && d.classList.contains('is-empty') && el.closest('.tp-cart-drawer__items, .tp-cart-drawer__extras, .tp-cart-drawer__footer, .tp-cart-drawer__shipping-bar')) return false;
    return true;
  }
  function focusEl(el) { if (!el) return false; try { el.focus({ preventScroll: false }); } catch (e) { return false; } return document.activeElement === el; }
  function restoreFocus(info) {
    if (!info) return;
    const d = getDrawer();
    if (!d || !d.classList.contains('is-open')) return;
    if (!info.inItems) {
      if (isShown(info.el)) return;
      const checkout = document.getElementById('tpCartCheckoutBtn');
      if (lastItemCount > 0 && isShown(checkout) && focusEl(checkout)) return;
      focusEl(document.getElementById('tpCartCloseBtn'));
      return;
    }
    const rows = Array.from(document.querySelectorAll('#tpCartItems .tp-cart-item'));
    const pick = (row) => {
      if (!row) return null;
      if (info.link) return row.querySelector('.tp-cart-item__name a');
      return (info.action && row.querySelector('button[data-action="' + info.action + '"]')) || row.querySelector('button[data-action="remove"]');
    };
    const same = rows.find((r) => r.dataset.key === info.key);
    const target = pick(same) || pick(rows[info.index]) || pick(rows[info.index - 1]);
    if (target && isShown(target) && focusEl(target)) return;
    const cta = document.getElementById('tpCartEmptyCta');
    if (lastItemCount === 0 && isShown(cta) && focusEl(cta)) return;
    focusEl(document.getElementById('tpCartCloseBtn'));
  }

  /* ======================= MESSAGES (lecteurs d'ecran + erreurs) =======================
     #tpCartLive (role=status) : « Brosse : quantite 2 », « Brosse retire du
     panier »... Le texte est vide puis reecrit pour qu'un message identique
     soit annonce a nouveau. Erreurs (role=alert) : dans la ligne concernee si
     elle existe, sinon dans la zone #tpCartError du panneau. */
  function announce(text) {
    const live = document.getElementById('tpCartLive');
    if (!live) return;
    live.textContent = '';
    window.setTimeout(() => { live.textContent = text; }, 60);
  }
  function clearCartErrors() {
    document.querySelectorAll('#tpCartItems .tp-cart-item__error').forEach((el) => el.remove());
    const global = document.getElementById('tpCartError');
    if (global) { global.hidden = true; global.textContent = ''; }
  }
  function showCartError(text, key) {
    const row = key ? Array.from(document.querySelectorAll('#tpCartItems .tp-cart-item')).find((r) => r.dataset.key === key) : null;
    const info = row ? row.querySelector('.tp-cart-item__info') : null;
    if (info) {
      let p = info.querySelector('.tp-cart-item__error');
      if (!p) { p = document.createElement('p'); p.className = 'tp-cart-item__error'; p.setAttribute('role', 'alert'); info.appendChild(p); }
      p.textContent = text;
      return;
    }
    const global = document.getElementById('tpCartError');
    if (!global) return;
    global.hidden = false;
    global.textContent = text;
  }
  /* Apres une action du pied (code promo, VIP20) : si l'element focalise a
     disparu ou a ete desactive, focus sur l'element prefere, sinon « Commander »,
     sinon Fermer. */
  function refocusIfLost(preferred) {
    const d = getDrawer();
    if (!d || !d.classList.contains('is-open')) return;
    const a = document.activeElement;
    if (a && a !== document.body && d.contains(a) && isShown(a) && !a.disabled) return;
    if (preferred && isShown(preferred) && focusEl(preferred)) return;
    const checkout = document.getElementById('tpCartCheckoutBtn');
    if (lastItemCount > 0 && isShown(checkout) && focusEl(checkout)) return;
    focusEl(document.getElementById('tpCartCloseBtn'));
  }
  function cartErrorText(err, fallback) {
    if (err && err.detail) return err.detail;
    return err && err.status ? fallback : 'Connexion impossible. Vérifiez votre réseau puis réessayez.';
  }

  function updateGuideBlock(cart) {
    const guide = document.getElementById('tpCartGuide');
    if (!guide) return;
    if (cartHasPackDuo(cart)) { guide.hidden = false; requestAnimationFrame(() => guide.classList.add('is-visible')); }
    else { guide.classList.remove('is-visible'); guide.hidden = true; }
  }

  /* Image d'un upsell : elle suit TOUJOURS la variante cochee.
     L'URL vient du serveur (data-image de chaque radio, resolue par
     snippets/toudoupet-variant-image.liquid) : aucune URL n'est construite ici.
     La nouvelle image est prechargee avant l'echange -> pas de flash de
     l'ancienne, pas de trou, et le conteneur garde ses dimensions.
     tpPending : en cas de clics rapides (Rose -> Gris -> Bleu), seule la
     derniere couleur demandee peut s'appliquer, meme si un chargement plus
     ancien se termine apres. En cas d'echec de chargement on echange quand
     meme : mieux vaut une image manquante qu'une image qui ment sur la
     variante qui sera ajoutee au panier. */
  function setUpsellImage(card, url) {
    if (!card || !url) return;
    const img = card.querySelector('[data-tp-upsell-img]');
    if (!img || img.getAttribute('src') === url) return;
    img.dataset.tpPending = url;
    const apply = () => {
      if (img.dataset.tpPending !== url) return;
      img.src = url;
      img.classList.remove('is-swapping');
    };
    const next = new Image();
    next.addEventListener('load', apply, { once: true });
    next.addEventListener('error', apply, { once: true });
    img.classList.add('is-swapping');
    next.src = url;
  }

  /* ======================= PACK RECOMMANDE =======================
     Index #tpCartPackIndex (Liquid : collection packs-offres + metachamp
     custom.pack_composants). Regle : au moins 2 composants DISTINCTS du pack
     dans le panier (2 unites d'un meme produit ne comptent qu'une fois), pack
     disponible, pack absent du panier. Une seule carte : priorite au plus grand
     nombre de composants presents, puis a la meilleure economie reelle, puis
     au titre (ordre stable, jamais de bascule au rafraichissement). Le JS ne
     modifie jamais le panier : le CTA mene a la fiche du pack. */
  let PACK_INDEX = {};
  try { const n = document.getElementById('tpCartPackIndex'); if (n) PACK_INDEX = JSON.parse(n.textContent) || {}; } catch (e) { PACK_INDEX = {}; }
  function pickPackReco(cart) {
    const inCart = Array.from(new Set((cart.items || []).map((i) => String(i.product_id))));
    const best = Object.keys(PACK_INDEX).map((id) => {
      const p = PACK_INDEX[id];
      if (inCart.includes(String(id))) return null;
      const have = (p.comp || []).filter((c) => inCart.includes(String(c)));
      return have.length >= 2 ? { id, p, have: have.length } : null;
    }).filter(Boolean).sort((a, b) => (b.have - a.have) || (b.p.eco - a.p.eco) || a.p.title.localeCompare(b.p.title, 'fr'));
    return best[0] || null;
  }
  function updatePackReco(cart) {
    const box = document.getElementById('tpCartPack');
    if (!box) return;
    const pick = pickPackReco(cart);
    if (!pick) { box.hidden = true; box.innerHTML = ''; box.dataset.pack = ''; return; }
    if (box.dataset.pack === String(pick.id) + ':' + pick.have) { box.hidden = false; return; }
    const p = pick.p;
    box.innerHTML = `${p.img ? `<a class="tp-cart-pack__media" href="${escapeHtml(p.url)}" tabindex="-1" aria-hidden="true"><img src="${escapeHtml(p.img)}" alt="" width="56" height="56" loading="lazy"></a>` : '<span class="tp-cart-pack__media"></span>'}
      <div class="tp-cart-pack__body">
        <span class="tp-cart-pack__eyebrow">Vous avez déjà ${pick.have} produits de ce pack</span>
        <p class="tp-cart-pack__title">${escapeHtml(p.title)}</p>
        <p class="tp-cart-pack__meta"><span>${priceHtml(p.price, 'tp-price--compact')}</span>${p.eco > 0 ? `<span class="tp-cart-pack__save">Économisez ${escapeHtml(formatEuros(p.eco))}</span>` : ''}</p>
        <a class="tp-cart-pack__cta" href="${escapeHtml(p.url)}">Découvrir le pack</a>
      </div>`;
    box.dataset.pack = String(pick.id) + ':' + pick.have;
    box.hidden = false;
  }

  /* ======================= BLOC VIP DU PANIER =======================
     Membre : « Economisez XX € avec votre code VIP20. Appliquer le code ? »
     uniquement si l'economie reelle est > 0 (lignes eligibles, hors prix
     exclusifs) et si VIP20 n'est pas deja au panier. Si un autre code client
     est APPLIQUE, VIP20 n'est pas cumulable : on l'indique, sans bouton (un
     code refuse par Shopify n'est pas compte).
     Non-membre : une ligne discrete vers la page du programme, sans masquer le
     prix public ni toucher au panier. Le bouton applique reellement le code ;
     l'eligibilite reste tranchee par Shopify (segment) au panier/checkout. */
  function vipStateKey(cart) {
    const codes = activeCustomerCodes(cart).map((c) => c.toUpperCase());
    return [VIP.member ? 'm' : 'v', cart.item_count, vipSavings(cart), codes.join('|')].join(':');
  }
  function updateVipBlock(cart) {
    const box = document.getElementById('tpCartVip');
    if (!box) return;
    /* Panier « adhesion seule » : aucun produit auquel VIP20 / les prix membres
       pourraient s'appliquer -> ni invitation au programme, ni proposition de
       code. Retour au comportement habituel des qu'un produit expediable revient. */
    if (!VIP.code || cart.item_count === 0 || isMembershipOnlyCart(cart)) { box.hidden = true; box.innerHTML = ''; box.dataset.state = ''; return; }
    const key = vipStateKey(cart);
    if (box.dataset.state === key && !box.hidden) return;
    box.dataset.state = key;
    const code = String(VIP.code);
    if (!VIP.member) {
      if (!VIP.page) { box.hidden = true; box.innerHTML = ''; return; }
      box.className = 'tp-cart-vip tp-cart-vip--guest';
      box.innerHTML = `<p class="tp-cart-vip__guest">${escapeHtml(VIP.programme || 'ToudouPet VIP')} : −${VIP.pct} % sur tous les produits et packs avec le code ${escapeHtml(code)}, prix membres et livraison offerte dès ${escapeHtml(formatEuros(Number(VIP.shipThreshold) || FREE_SHIPPING_THRESHOLD))} d’achats. <a href="${escapeHtml(VIP.page)}">Découvrir le programme</a>${VIP.loginUrl ? ` · <a href="${escapeHtml(VIP.loginUrl)}">Déjà membre ? Connectez-vous</a>` : ''}</p>`;
      box.hidden = false;
      return;
    }
    const savings = vipSavings(cart);
    /* Seuls les codes que Shopify applique comptent : un code invalide,
       expire ou refuse (applicable:false) ne bloque jamais la proposition VIP20. */
    const codes = activeCustomerCodes(cart);
    const applied = codes.some((c) => c.toUpperCase() === code.toUpperCase() && (cart.discount_codes || []).some((d) => d.code && d.code.toUpperCase() === code.toUpperCase() && d.applicable !== false));
    if (applied || savings <= 0) { box.hidden = true; box.innerHTML = ''; return; }
    const others = codes.filter((c) => c.toUpperCase() !== code.toUpperCase());
    box.className = 'tp-cart-vip tp-cart-vip--member';
    if (others.length) {
      box.innerHTML = `<p class="tp-cart-vip__text"><span class="tp-cart-vip__badge">VIP</span> Votre code ${escapeHtml(code)} n'est pas cumulable avec le code ${escapeHtml(others.join(', '))} déjà appliqué.</p>`;
      box.hidden = false;
      return;
    }
    box.innerHTML = `<p class="tp-cart-vip__text"><span class="tp-cart-vip__badge">VIP</span> Économisez <strong>${escapeHtml(formatEuros(savings))}</strong> avec votre code ${escapeHtml(code)}. Appliquer le code ?</p>
      <button type="button" class="tp-cart-vip__apply" data-tp-vip-apply data-label="Appliquer ${escapeHtml(code)}">Appliquer ${escapeHtml(code)}</button>
      <p class="tp-cart-vip__error" role="alert" hidden></p>
      <p class="tp-cart-vip__guest">Une seule réduction produit par article : l’avantage applicable le plus élevé est conservé.</p>`;
    box.hidden = false;
  }
  async function applyVipCode(btn) {
    const box = document.getElementById('tpCartVip');
    const err = box ? box.querySelector('.tp-cart-vip__error') : null;
    if (!VIP.code || !btn || btn.disabled) return;
    btn.disabled = true; btn.textContent = 'Application…';
    if (err) err.hidden = true;
    try {
      await applyCustomerCode(String(VIP.code));
      const cart = await refreshCartDrawer();
      const entry = (cart.discount_codes || []).find((d) => d && d.code && d.code.toUpperCase() === String(VIP.code).toUpperCase());
      if (!entry || entry.applicable === false) {
        /* Le code est reste sans effet : on le retire pour ne pas laisser un
           code inapplicable au panier, et on l'explique. */
        const keep = cartCodes(cart).filter((c) => c.toUpperCase() !== String(VIP.code).toUpperCase());
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: keep.join(',') }) });
        const cart2 = await refreshCartDrawer();
        const b2 = document.getElementById('tpCartVip');
        const e2 = b2 ? b2.querySelector('.tp-cart-vip__error') : null;
        const btn2 = b2 ? b2.querySelector('[data-tp-vip-apply]') : null;
        if (e2) { e2.textContent = 'Le code n’a pas pu être appliqué. Vérifiez que vous êtes connecté(e) et que votre adhésion VIP est active.'; e2.hidden = false; }
        if (btn2) { btn2.disabled = false; btn2.textContent = btn2.dataset.label || 'Appliquer'; }
        void cart2;
        refocusIfLost(btn2);
        return;
      }
      const toast = document.getElementById('tpSavingsToast');
      const amount = (cart.items || []).reduce((s, item) => s + (item.line_level_discount_allocations || []).filter((al) => al.discount_application && al.discount_application.type === 'discount_code').reduce((t, al) => t + (al.amount || 0), 0), 0);
      if (toast && amount > 0) { toast.textContent = 'Vous économisez ' + formatEuros(amount) + ' grâce à votre code ' + String(VIP.code) + ' !'; toast.classList.remove('is-active'); void toast.offsetWidth; toast.classList.add('is-active'); }
      if (amount > 0) announce('Code ' + String(VIP.code) + ' appliqué : vous économisez ' + formatEuros(amount) + '.');
      refocusIfLost(null);
    } catch (e) {
      const b2 = document.getElementById('tpCartVip');
      const e2 = b2 ? b2.querySelector('.tp-cart-vip__error') : null;
      const btn2 = b2 ? b2.querySelector('[data-tp-vip-apply]') : null;
      if (e2) { e2.textContent = 'Une erreur est survenue, veuillez réessayer.'; e2.hidden = false; }
      if (btn2) { btn2.disabled = false; btn2.textContent = btn2.dataset.label || 'Appliquer'; }
      refocusIfLost(btn2);
    }
  }

  function getDismissed() { try { return JSON.parse(sessionStorage.getItem(DISMISS_KEY) || '[]'); } catch (e) { return []; } }
  function dismissProduct(id) {
    const list = getDismissed();
    if (!list.includes(String(id))) list.push(String(id));
    try { sessionStorage.setItem(DISMISS_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function updateUpsellBlock(cart) {
    const wrap = document.getElementById('tpCartUpsell');
    if (!wrap) return;
    const cartIds = cart.items.map((item) => String(item.product_id));
    /* Declencheurs : IDs (lignes deja au panier au rendu, packs de la famille)
       ou handles (produit ajoute depuis : /cart.js donne items[].handle). */
    const cartHandles = cart.items.map((item) => String(item.handle || ''));
    const dismissed = getDismissed();
    const candidates = Array.from(wrap.querySelectorAll('[data-tp-upsell-item]'));
    let pick = null;
    if (cart.item_count > 0) {
      pick = candidates.find((el) => {
        if (el.dataset.available !== 'true') return false;
        const pid = String(el.dataset.productId);
        const family = [pid].concat(String(el.dataset.productFamilyIds || '').split(',')).filter(Boolean);
        if (family.some((id) => cartIds.includes(id)) || dismissed.includes(pid)) return false;
        return String(el.dataset.triggerIds).split(',').some((id) => id && cartIds.includes(id))
          || String(el.dataset.triggerHandles || '').split(',').some((h) => h && cartHandles.includes(h));
      }) || null;
    }
    candidates.forEach((el) => { const show = el === pick; el.hidden = !show; el.classList.toggle('is-visible', show); });
    wrap.hidden = !pick;
  }

  /* Les codes internes ne sont jamais presentes comme des codes client. */
  function updatePromoState(cart) {
    const details = document.getElementById('tpPromoDetails');
    const row = document.getElementById('tpPromoRow');
    const applied = document.getElementById('tpPromoApplied');
    const appliedText = document.getElementById('tpPromoAppliedText');
    if (!details || !row || !applied) return;
    const codes = activeCustomerCodes(cart);
    const has = codes.length > 0;
    /* Panier « adhesion seule » sans code deja applique : l'accordeon « code
       promo » est masque (rien a quoi appliquer un code). Un code deja present
       reste visible et retirable ; un produit expediable le fait reapparaitre. */
    details.hidden = isMembershipOnlyCart(cart) && !has;
    row.hidden = has;
    applied.hidden = !has;
    if (has) { details.open = true; if (appliedText) appliedText.textContent = 'Code appliqué : ' + codes.join(', '); }
  }

  function renderIfFresh(cart, seq) {
    if (seq < renderedSeq) return;
    renderedSeq = seq;
    renderCartItems(cart);
  }
  async function refreshCartDrawer() {
    const seq = ++cartSeq;
    let cart = await fetchCart();
    cart = await syncInternalDiscount(cart);
    renderIfFresh(cart, seq);
    return cart;
  }
  function bounceCartIcon() { const icon = document.getElementById('tpCartIconBtn'); if (!icon) return; icon.classList.remove('is-bouncing'); void icon.offsetWidth; icon.classList.add('is-bouncing'); }

  async function addToCart(variantIdOrItems, quantity, options) {
    options = options || {};
    const items = Array.isArray(variantIdOrItems) ? variantIdOrItems : [{ id: variantIdOrItems, quantity: quantity || 1 }];
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
    if (!response.ok) {
      let message = 'Ajout au panier impossible'; let detail = '';
      try { const data = await response.json(); detail = data.description || ''; message = data.description || data.message || message; } catch (e) {}
      const error = new Error(message); error.status = response.status; error.detail = detail; throw error;
    }
    if (options.refresh !== false) await refreshCartDrawer();
    if (options.openDrawer !== false) openCartDrawer(options.trigger);
    if (options.bounce !== false) bounceCartIcon();
  }
  /* /cart/change.js renvoie deja le panier complet : une seule requete par
     action. Repli sur GET /cart.js si la reponse ne porte pas discount_codes
     (necessaires au bloc VIP et au code promo). Refus (422 stock...) ou
     reseau : l'erreur remonte a l'appelant, le panier affiche reste tel quel. */
  async function changeItemQuantity(key, quantity) {
    const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity }) });
    let cart = await readCartResponse(response, 'Mise à jour impossible');
    const seq = ++cartSeq;
    if (!Array.isArray(cart.discount_codes)) cart = await fetchCart();
    cart = await syncInternalDiscount(cart);
    renderIfFresh(cart, seq);
    return cart;
  }

  /* ======================= QUANTITES : UNE ACTION A LA FOIS =======================
     Pendant une mutation, la ligne passe en aria-busy (.is-busy) et tous les
     boutons +/−/× du panier en aria-disabled (pas disabled : le bouton garde
     le focus clavier). Les clics recus pendant ce temps sont ignores : un clic
     = une mutation, jamais deux requetes qui envoient la meme quantite. La
     quantite cible part de l'etat panier connu (lastCart), pas du texte affiche. */
  function setItemsBusy(row, on) {
    const container = document.getElementById('tpCartItems');
    if (!container) return;
    container.querySelectorAll('button[data-action]').forEach((b) => { if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); });
    if (on && row) { row.classList.add('is-busy'); row.setAttribute('aria-busy', 'true'); }
    if (!on) container.querySelectorAll('.tp-cart-item.is-busy').forEach((r) => { r.classList.remove('is-busy'); r.removeAttribute('aria-busy'); });
  }
  function updateLine(btn) {
    if (lineMutation || btn.getAttribute('aria-disabled') === 'true') return lineMutation;
    const row = btn.closest('.tp-cart-item');
    const key = btn.dataset.key;
    const action = btn.dataset.action;
    const known = lastCart ? (lastCart.items || []).find((i) => i.key === key) : null;
    const qtyEl = row ? row.querySelector('.tp-cart-item__qty-value') : null;
    const nameEl = row ? row.querySelector('.tp-cart-item__name') : null;
    const current = known ? known.quantity : (parseInt(qtyEl ? qtyEl.textContent : '', 10) || 1);
    const title = known ? known.product_title : (nameEl ? nameEl.textContent.trim() : 'Article');
    const target = action === 'plus' ? current + 1 : action === 'minus' ? Math.max(0, current - 1) : 0;
    clearCartErrors();
    setItemsBusy(row, true);
    lineMutation = changeItemQuantity(key, target).then((cart) => {
      setItemsBusy(null, false);
      const line = (cart.items || []).find((i) => i.key === key);
      if (!line) { announce(title + ' retiré du panier.'); return; }
      if (target > current && line.quantity < target) {
        /* Shopify a plafonne la quantite au stock disponible (reponse 200). */
        const msg = 'Stock limité : ' + line.quantity + ' exemplaire' + (line.quantity > 1 ? 's' : '') + ' maximum pour cet article.';
        showCartError(msg, key);
        return;
      }
      announce(title + ' : quantité ' + line.quantity + '.');
    }).catch((err) => {
      setItemsBusy(null, false);
      showCartError(cartErrorText(err, 'Mise à jour impossible pour le moment. Réessayez.'), key);
    }).then(() => { lineMutation = null; });
    return lineMutation;
  }

  let initialized = false;
  document.addEventListener('DOMContentLoaded', () => {
    /* Une seule initialisation, meme si l'evenement est emis deux fois. */
    if (initialized) return;
    initialized = true;
    const cartIconBtn = document.getElementById('tpCartIconBtn');
    const cartCloseBtn = document.getElementById('tpCartCloseBtn');
    if (cartIconBtn) cartIconBtn.addEventListener('click', (e) => {
      e.preventDefault();
      /* Le drawer s'ouvre tout de suite sur l'etat connu ; s'il ne peut pas
         etre actualise (reseau), on le dit au lieu d'echouer en silence.
         Les messages d'une action precedente sont effaces. */
      clearCartErrors();
      refreshCartDrawer().catch((err) => showCartError(cartErrorText(err, 'Impossible d’actualiser le panier pour le moment. Réessayez.')));
      openCartDrawer(cartIconBtn);
    });
    if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCartDrawer);
    const cartDrawer = getDrawer();
    if (cartDrawer) cartDrawer.addEventListener('click', (e) => { if (!cartDrawer.contains(e.target)) return; if (e.target.closest('.tp-cart-drawer__panel')) return; closeCartDrawer(); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeCartDrawer();
      else if (e.key === 'Tab') trapTab(e);
    });
    /* Easter egg : rejouer le camion. Ne touche ni au panier ni au seuil ;
       ignore pendant qu'un passage est deja en cours ou sous le seuil. */
    document.addEventListener('click', (e) => {
      const truck = e.target.closest('[data-tp-ship-truck]');
      if (!truck) return;
      e.preventDefault();
      if (ship.unlocked && ship.shown >= 0.999 && !ship.truckPlaying && !ship.opening) playTruck();
    });
    /* Bouton « Appliquer VIP20 » (delegue : le bloc est reconstruit par le JS). */
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-tp-vip-apply]');
      if (!btn) return;
      e.preventDefault();
      applyVipCode(btn);
    });
    updateEmptyState(lastItemCount);
    /* Chargement : le drawer est deja rendu en Liquid. Panier vide -> aucune
       requete. Panier non vide -> une lecture /cart.js, qui remplit la barre de
       livraison et les blocs VIP / pack et retire d'eventuels anciens codes
       internes (ils n'existent que dans un panier non vide). Chaque ouverture
       et chaque ajout relisent de toute facon le panier. */
    if (lastItemCount > 0) refreshCartDrawer().catch(() => {});

    /* Commander : lien direct vers /checkout. On ne le retient que si une
       action panier est encore en cours (on attend sa reponse) ou si un ancien
       code interne doit etre retire ; dans les deux cas au plus ~1,5 s, avec un
       etat « occupe » visible. Cmd/Ctrl/Maj-clic et clic molette : comportement
       natif du lien. */
    const checkoutBtn = document.getElementById('tpCartCheckoutBtn');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', async (e) => {
        if (lastItemCount === 0) { e.preventDefault(); const cta = document.getElementById('tpCartEmptyCta'); if (cta) cta.focus(); return; }
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (typeof e.button === 'number' && e.button !== 0)) return;
        e.preventDefault();
        if (checkoutBtn.classList.contains('is-busy')) return;
        checkoutBtn.classList.add('is-busy');
        checkoutBtn.setAttribute('aria-busy', 'true');
        const waits = [];
        if (lineMutation) waits.push(lineMutation);
        if (!lastCart || cartCodes(lastCart).some(isInternal)) waits.push(refreshCartDrawer());
        if (waits.length) { try { await Promise.race([Promise.all(waits), new Promise((resolve) => window.setTimeout(resolve, 1500))]); } catch (err) {} }
        window.location.href = checkoutBtn.getAttribute('href') || '/checkout';
      });
      /* Retour arriere depuis le checkout (page restauree du cache) : on
         retire l'etat « occupe ». */
      window.addEventListener('pageshow', () => { checkoutBtn.classList.remove('is-busy'); checkoutBtn.removeAttribute('aria-busy'); });
    }

    const itemsContainer = document.getElementById('tpCartItems');
    if (itemsContainer) {
      itemsContainer.addEventListener('click', (e) => {
        const btn = e.target.closest('button[data-action]');
        if (!btn) return;
        updateLine(btn);
      });
    }

    const upsellWrap = document.getElementById('tpCartUpsell');
    if (upsellWrap) {
      upsellWrap.addEventListener('change', (e) => {
        const radio = e.target.closest('[data-tp-upsell-variant]');
        if (!radio) return;
        const card = radio.closest('[data-tp-upsell-item]');
        const price = card ? card.querySelector('[data-tp-upsell-price]') : null;
        const add = card ? card.querySelector('[data-tp-upsell-add]') : null;
        if (price && radio.dataset.priceCents) renderPriceInto(price, radio.dataset.priceCents, 'tp-price--compact');
        if (add) add.dataset.tpUpsellAdd = radio.value;
        setUpsellImage(card, radio.dataset.image);
      });
      upsellWrap.addEventListener('click', async (e) => {
        const dismiss = e.target.closest('[data-tp-upsell-dismiss]');
        if (dismiss) {
          const card = dismiss.closest('[data-tp-upsell-item]');
          if (card) dismissProduct(card.dataset.productId);
          if (lastCart) updateUpsellBlock(lastCart); else refreshCartDrawer().catch(() => {});
          /* La carte masquee avait le focus : on le rend au bouton Fermer. */
          if (card && card.hidden) focusEl(document.getElementById('tpCartCloseBtn'));
          return;
        }
        const btn = e.target.closest('[data-tp-upsell-add]');
        if (!btn || btn.disabled) return;
        const card = btn.closest('[data-tp-upsell-item]');
        const checked = card ? card.querySelector('[data-tp-upsell-variant]:checked') : null;
        const variantId = checked ? checked.value : btn.dataset.tpUpsellAdd;
        const idle = btn.dataset.label || btn.textContent.trim();
        btn.disabled = true; btn.textContent = 'Ajout…';
        try {
          await addToCart(variantId, 1, { openDrawer: false, bounce: true });
          btn.classList.add('is-added'); btn.textContent = 'Ajouté ✓';
          /* La carte disparait (produit desormais au panier) : annonce, et le
             focus passe sur la nouvelle ligne plutot que de retomber sur la page. */
          const added = lastCart ? (lastCart.items || []).find((i) => String(i.variant_id) === String(variantId)) : null;
          if (added) {
            announce(added.product_title + ' ajouté au panier.');
            if (!isShown(btn)) {
              const row = Array.from(document.querySelectorAll('#tpCartItems .tp-cart-item')).find((r) => r.dataset.key === added.key);
              focusEl(row ? row.querySelector('.tp-cart-item__name a') : null);
            }
          }
          window.setTimeout(() => { btn.classList.remove('is-added'); btn.disabled = false; btn.textContent = idle; }, 1200);
        } catch (err) {
          btn.textContent = 'Réessayer';
          window.setTimeout(() => { btn.disabled = false; btn.textContent = idle; }, 2000);
          if (window.console) console.warn('[ToudouPet] Cross-sell refusé :', err && err.message ? err.message : err);
        }
      });
    }

    const promoInput = document.getElementById('tpPromoInput');
    const promoApplyBtn = document.getElementById('tpPromoApplyBtn');
    const promoBtnText = document.getElementById('tpPromoBtnText');
    const promoIcon = document.getElementById('tpPromoIcon');
    const promoMessage = document.getElementById('tpPromoMessage');
    const promoRemove = document.getElementById('tpPromoRemove');
    const confettiContainer = document.getElementById('tpConfettiContainer');
    const CHECK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="#4A8B5C" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
    const ERROR_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="#B3564A" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="M6 6l12 12"/></svg>';
    function resetPromoState() {
      if (promoInput) promoInput.classList.remove('is-success', 'is-error');
      if (promoIcon) promoIcon.classList.remove('is-visible');
      if (promoMessage) promoMessage.hidden = true;
      const promoSavings = document.getElementById('tpPromoSavings');
      if (promoSavings) { promoSavings.classList.remove('is-visible'); promoSavings.hidden = true; }
    }
    function showPromoError(text) {
      if (promoInput) promoInput.classList.add('is-error');
      if (promoIcon) { promoIcon.innerHTML = ERROR_ICON; promoIcon.classList.add('is-visible'); }
      promoMessage.textContent = text; promoMessage.className = 'tp-cart-drawer__promo-message is-error'; promoMessage.hidden = false;
    }
    function launchConfetti() {
      if (!confettiContainer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const colors = ['#B07A45', '#3C2A1E', '#E8D9C3', '#1E1B18'];
      for (let i = 0; i < 18; i++) {
        const piece = document.createElement('span');
        piece.className = 'tp-confetti-piece';
        piece.style.left = Math.random() * 90 + '%';
        piece.style.background = colors[Math.floor(Math.random() * colors.length)];
        piece.style.setProperty('--tp-confetti-x', (Math.random() * 40 - 20) + 'px');
        piece.style.setProperty('--tp-confetti-r', (Math.random() * 360) + 'deg');
        piece.style.animationDelay = (Math.random() * 0.1) + 's';
        confettiContainer.appendChild(piece);
        setTimeout(() => piece.remove(), 900);
      }
    }
    function codeState(cart, code) {
      const entry = (cart.discount_codes || []).find((d) => d && d.code && d.code.toUpperCase() === code.toUpperCase());
      if (entry) return entry.applicable ? 'applied' : (automaticDiscounts(cart).some((a) => a.amount > 0) ? 'blocked' : 'invalid');
      return 'invalid';
    }

    if (promoInput && promoApplyBtn && promoMessage) {
      promoApplyBtn.addEventListener('click', async () => {
        const code = promoInput.value.trim();
        resetPromoState();
        if (!code) { showPromoError('Veuillez saisir un code.'); return; }
        if (isInternal(code)) { showPromoError('Ce code promotionnel est invalide ou a expiré.'); return; }
        promoApplyBtn.disabled = true; promoBtnText.textContent = '...';
        const minLoadingTime = new Promise((resolve) => setTimeout(resolve, 250));
        try {
          await applyCustomerCode(code);
          const cart = await refreshCartDrawer();
          await minLoadingTime;
          const state = codeState(cart, code);
          if (state === 'applied') {
            promoInput.classList.add('is-success'); if (promoIcon) { promoIcon.innerHTML = CHECK_ICON; promoIcon.classList.add('is-visible'); }
            promoMessage.textContent = 'Code appliqué avec succès !'; promoMessage.className = 'tp-cart-drawer__promo-message is-success'; promoMessage.hidden = false;
            const subtotalRow = document.querySelector('.tp-cart-drawer__subtotal');
            if (subtotalRow) { subtotalRow.classList.add('is-updating'); setTimeout(() => subtotalRow.classList.remove('is-updating'), 250); }
            launchConfetti();
            const codeAmount = (cart.cart_level_discount_applications || []).filter((a) => a.type === 'discount_code').reduce((s, a) => s + (a.total_allocated_amount || 0), 0)
              + (cart.items || []).reduce((s, item) => s + (item.line_level_discount_allocations || []).filter((al) => al.discount_application && al.discount_application.type === 'discount_code').reduce((t, al) => t + (al.amount || 0), 0), 0);
            const promoSavings = document.getElementById('tpPromoSavings');
            if (codeAmount > 0 && promoSavings) { promoSavings.textContent = 'Vous économisez ' + formatEuros(codeAmount) + ' sur cette commande.'; promoSavings.hidden = false; requestAnimationFrame(() => promoSavings.classList.add('is-visible')); }
            const toast = document.getElementById('tpSavingsToast');
            if (codeAmount > 0 && toast) { toast.textContent = 'Vous économisez ' + formatEuros(codeAmount) + ' grâce à votre code promo !'; toast.classList.remove('is-active'); void toast.offsetWidth; toast.classList.add('is-active'); }
            promoInput.value = '';
          } else {
            /* Code refuse par Shopify (applicable:false) ou absent : il est
               retire du panier pour ne rien laisser d'inapplicable (il ne doit
               ni bloquer VIP20, ni rester invisible et non retirable).
               Shopify ne dit pas POURQUOI un code est refuse : avec une remise
               automatique au panier, le message couvre aussi la non-cumulabilite
               sans l'affirmer. */
            const isVipCode = VIP.code && code.toUpperCase() === String(VIP.code).toUpperCase();
            const isOtherVipCode = VIP.otherCode && code.toUpperCase() === String(VIP.otherCode).toUpperCase();
            const present = cartCodes(cart).some((c) => c.toUpperCase() === code.toUpperCase());
            if (present) {
              const keep = cartCodes(cart).filter((c) => c.toUpperCase() !== code.toUpperCase());
              await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: keep.join(',') }) });
              await refreshCartDrawer();
            }
            if ((isVipCode || isOtherVipCode) && !VIP.member) showPromoError('Ce code est réservé aux membres ToudouPet VIP connectés.');
            else if (isOtherVipCode && VIP.historic) showPromoError('Votre code membre fondateur est ' + String(VIP.code) + ' (−' + VIP.pct + ' %) : le code ' + String(VIP.otherCode) + ' ne s’applique pas à votre compte.');
            else if (isOtherVipCode) showPromoError('Le code ' + String(VIP.otherCode) + ' est réservé aux membres fondateurs. Votre code membre est ' + String(VIP.code) + '.');
            else if (isVipCode) showPromoError('Le code ' + String(VIP.code) + ' ne s’applique pas à ce panier (aucun article éligible ou offre non cumulable).');
            else if (state === 'blocked') showPromoError('Ce code ne s’applique pas à ce panier : il est invalide, a expiré, ses conditions ne sont pas remplies ou il n’est pas cumulable avec l’offre en cours.');
            else showPromoError('Ce code promotionnel est invalide, a expiré ou ses conditions ne sont pas remplies.');
          }
        } catch (err) {
          await minLoadingTime;
          showPromoError('Une erreur est survenue, veuillez réessayer.');
        }
        promoApplyBtn.disabled = false; promoBtnText.textContent = 'Appliquer';
        /* Bouton desactive pendant la requete, ou rangee masquee une fois le
           code applique : le focus ne doit pas retomber sur la page. */
        refocusIfLost(promoInput);
      });
      promoInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); promoApplyBtn.click(); } });
      promoInput.addEventListener('input', resetPromoState);
    }
    /* Retirer le code CLIENT : on ne garde que d'eventuels anciens codes internes, qui sont retires par la synchro. */
    if (promoRemove) {
      promoRemove.addEventListener('click', async () => {
        promoRemove.disabled = true;
        try {
          const cart0 = await fetchCart();
          const keep = cartCodes(cart0).filter(isInternal);
          await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: keep.join(',') }) });
          await refreshCartDrawer();
          resetPromoState();
          const row = document.getElementById('tpPromoRow');
          if (row) { row.hidden = false; }
          const applied = document.getElementById('tpPromoApplied');
          if (applied) applied.hidden = true;
          if (promoInput) promoInput.focus();
        } catch (err) { if (promoMessage) { promoMessage.textContent = 'Impossible de retirer le code pour le moment.'; promoMessage.className = 'tp-cart-drawer__promo-message is-error'; promoMessage.hidden = false; } }
        promoRemove.disabled = false;
        refocusIfLost(promoRemove);
      });
    }
  });

  /* B2-1 (20/10/2026) garde-fou panier VIP mixte : aucun passage au paiement avec adhésion + produits. ACTIVÉ le 20/10 (TP_VIP_GUARD_ON = true ; remettre false pour le désactiver). Les articles mis de côté reviennent au panier au retour sur la boutique. Retour arrière : supprimer ce bloc + l'appel tpVipGuardGo dans toudoupet-product.js. */ const TP_VIP_GUARD_ON = true; const TP_PARK_KEY = 'tpVipParked'; function tpGuardActive() { if (TP_VIP_GUARD_ON) return true; try { return window.localStorage.getItem('tpVipGuardTest') === '1'; } catch (e) { return false; } } function tpRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; } function tpIsPlanLine(i) { return !!i.selling_plan_allocation; } function tpIsMixedCart(c) { const it = (c && c.items) || []; return it.some(tpIsPlanLine) && it.some(function (i) { return !tpIsPlanLine(i); }); } function tpGoCheckout() { window.location.href = tpRoot() + 'checkout'; } async function tpCartJson() { const r = await fetch(tpRoot() + 'cart.js', { headers: { Accept: 'application/json' } }); if (!r.ok) throw new Error('cart'); return r.json(); } async function tpCartUpdate(upd) { const r = await fetch(tpRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: upd }) }); if (!r.ok) throw new Error('update'); return r.json(); } function tpToast(msg) { const t = document.createElement('p'); t.setAttribute('role', 'status'); t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;max-width:min(92vw,460px);margin:0;padding:12px 16px;border-radius:12px;background:#2B1D0E;color:#fff;font-size:14px;line-height:1.45;box-shadow:0 8px 24px rgba(0,0,0,.25);'; t.textContent = msg; document.body.appendChild(t); setTimeout(function () { t.remove(); }, 9000); } function tpCloseMixedDialog() { const d = document.getElementById('tpVipMixedDialog'); if (d) d.remove(); document.removeEventListener('keydown', tpMixedDialogKey, true); } function tpMixedDialogKey(e) { if (e.key === 'Escape') { e.preventDefault(); tpCloseMixedDialog(); } } function tpShowMixedDialog(c) { tpCloseMixedDialog(); const goods = c.items.filter(function (i) { return !tpIsPlanLine(i); }); const n = goods.reduce(function (s, i) { return s + i.quantity; }, 0); const lbl = n > 1 ? n + ' articles' : '1 article'; const ov = document.createElement('div'); ov.id = 'tpVipMixedDialog'; ov.style.cssText = 'position:fixed;inset:0;z-index:2147482000;background:rgba(20,14,6,.55);display:flex;align-items:center;justify-content:center;padding:16px;'; const box = document.createElement('div'); box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-labelledby', 'tpVipMixedTitle'); box.style.cssText = 'background:#FFFDF8;color:#2B1D0E;border-radius:16px;max-width:460px;width:100%;padding:22px 20px;box-shadow:0 12px 40px rgba(0,0,0,.3);font-size:15px;line-height:1.5;max-height:90vh;overflow:auto;'; const bs = 'display:block;width:100%;margin:10px 0 0;padding:12px 14px;border-radius:999px;font:inherit;font-weight:700;cursor:pointer;'; box.innerHTML = '<h2 id="tpVipMixedTitle" style="margin:0 0 8px;font-size:19px;line-height:1.3;">L’adhésion VIP se règle seule</h2><p style="margin:0 0 6px;">Votre panier contient l’adhésion ToudouPet VIP et ' + lbl + '. Les avantages VIP ne s’appliquent pas aux articles payés en même temps que l’adhésion : nous les séparons pour éviter tout malentendu.</p><button type="button" data-tp-act="member" style="' + bs + 'background:#2B1D0E;color:#fff;border:0;">Régler d’abord l’adhésion</button><p style="margin:4px 4px 0;font-size:13px;color:#5A4632;">Vos ' + lbl + ' sont mis de côté sur cet appareil et reviennent dans votre panier dès votre retour sur la boutique. La remise VIP ne s’applique qu’une fois l’adhésion confirmée et activée sur votre compte, connecté(e).</p><button type="button" data-tp-act="goods" style="' + bs + 'background:#fff;color:#2B1D0E;border:2px solid #2B1D0E;">Commander mes articles sans l’adhésion</button><button type="button" data-tp-act="close" style="' + bs + 'background:transparent;color:#2B1D0E;border:0;text-decoration:underline;font-weight:600;">Revenir au panier</button><p data-tp-err role="alert" hidden style="margin:10px 0 0;color:#9B1C1C;font-size:14px;"></p>'; ov.appendChild(box); document.body.appendChild(ov); document.addEventListener('keydown', tpMixedDialogKey, true); ov.addEventListener('click', function (e) { if (e.target === ov) tpCloseMixedDialog(); }); const err = box.querySelector('[data-tp-err]'); box.querySelectorAll('button[data-tp-act]').forEach(function (b) { b.addEventListener('click', async function () { const act = b.getAttribute('data-tp-act'); if (act === 'close') { tpCloseMixedDialog(); return; } box.querySelectorAll('button').forEach(function (x) { x.disabled = true; }); try { const cur = await tpCartJson(); const upd = {}; if (act === 'member') { const keep = cur.items.filter(function (i) { return !tpIsPlanLine(i); }); window.localStorage.setItem(TP_PARK_KEY, JSON.stringify({ t: Date.now(), items: keep.map(function (i) { return { id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }; }) })); keep.forEach(function (i) { upd[i.key] = 0; }); } else { cur.items.filter(tpIsPlanLine).forEach(function (i) { upd[i.key] = 0; }); } await tpCartUpdate(upd); tpGoCheckout(); } catch (e2) { box.querySelectorAll('button').forEach(function (x) { x.disabled = false; }); err.textContent = 'Une erreur est survenue, votre panier n’a pas été modifié. Réessayez ou contactez-nous.'; err.hidden = false; } }); }); const first = box.querySelector('button[data-tp-act="member"]'); if (first) first.focus(); } async function tpVipGuardGo() { if (!tpGuardActive()) { tpGoCheckout(); return; } let c; try { c = await tpCartJson(); } catch (e) { tpGoCheckout(); return; } if (!tpIsMixedCart(c)) { tpGoCheckout(); return; } tpShowMixedDialog(c); } window.tpVipGuardGo = tpVipGuardGo; async function tpRestoreParked() { let p = null; try { p = JSON.parse(window.localStorage.getItem(TP_PARK_KEY) || 'null'); } catch (e) { return; } if (!p || !Array.isArray(p.items) || !p.items.length) return; try { window.localStorage.removeItem(TP_PARK_KEY); } catch (e) { return; } if (Date.now() - (p.t || 0) > 30 * 24 * 3600 * 1000) return; let back = 0; let miss = 0; for (const it of p.items) { try { const r = await fetch(tpRoot() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [it] }) }); if (r.ok) back += it.quantity; else miss += 1; } catch (e) { miss += 1; } } if (typeof refreshCartDrawer === 'function') { try { await refreshCartDrawer(); } catch (e) {} } if (back > 0) tpToast((back > 1 ? 'Vos ' + back + ' articles mis de côté sont de retour' : 'Votre article mis de côté est de retour') + ' dans votre panier.' + (miss ? ' Certains articles ne sont plus disponibles.' : '')); else if (miss) tpToast('Les articles mis de côté ne sont plus disponibles.'); } document.addEventListener('click', function (e) { if (!tpGuardActive() || !e.target || !e.target.closest) return; const t = e.target.closest('#tpCartCheckoutBtn, a[href="/checkout"], button[name="checkout"], input[name="checkout"]'); if (!t || t.classList.contains('is-disabled')) return; e.preventDefault(); e.stopPropagation(); tpVipGuardGo(); }, true); window.addEventListener('pageshow', function (e) { if (e.persisted) tpRestoreParked(); }); if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tpRestoreParked); else tpRestoreParked(); window.ToudouCart = { addToCart, openCartDrawer, closeCartDrawer, refreshCartDrawer, bounceCartIcon, formatMoney: formatEuros, syncShippingDiscount: refreshCartDrawer, vip: { isMember: () => !!VIP.member, threshold: shipThreshold, savings: vipSavings } };
})();
